interface ITableBodyProps {
  children?: React.ReactNode
}

export const TableBody = ({ children }: ITableBodyProps) => {
  return <tbody>{children}</tbody>
}
